<template>

  <div class="container all">
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <div class="d-flex justify-content-center h-100">
      <div class="card">
        <b-row>
          <b-col cols="4">
            <img class="thumbnail" :src="thumbnail" @error="altImg">
          </b-col>
          <b-col class="text-left" cols="6">
            <h3>
              <i v-show="'ios' === platform" class="fa fa-apple mr-2" aria-hidden="true"></i>
              <i v-show="'android' === platform" class="fa fa-android mr-2" aria-hidden="true"></i>
              {{app.name}}</h3>
            <h6>Version {{version.version}} </h6>
            <h6> By {{version.createdBy}}</h6>
          </b-col>
          <b-col class="text-right"><li class="share-icon" style="float: right;"></li></b-col>
        </b-row>
        <hr>
        <Form>
          <fieldset class="pin-box">
            <legend class="legend-style">PIN Access</legend>
            <div class="pin-pre">&nbsp;</div>
            <input type="text" class="input-pin-style" v-model="pin" placeholder="Enter your PIN Access">
            <b-button pill class="get-btn-style" @click="initiateDownload">GET</b-button>
          </fieldset>
          <label class="download-message-label"><i class="fa fa-exclamation-circle"></i> {{downloadMessage}}</label>
        </Form>
        <b-progress
            height="2px"
            :value="pvalue"
            v-show="pvalue != 0"
        ></b-progress>
        <div class="card text-left my-2" v-if="showCarousel">
          <h5>Preview</h5>
          <carousel
                v-if="showCarousel"
                :starting-image="0"
                :images="images" class="carousel"
              ></carousel>
        </div>
        <hr class="properties-hr-style">
        <div class="card text-left my-2 properties">
          <h5>What's new <a href="#" class="hint toright">Version History</a></h5>
          <font class="hint">Version: {{version.version}}<label class="toright">{{releaseago}}</label></font>
          <font class="releasenotes"> {{version.noteNew}}</font>
        </div>
        <hr>
        <div class="card text-left my-2 information" id="information-card">
          <h5>Information</h5>
          <font class="hint">Provider<label>{{information.provider}}</label></font>
          <hr>
          <font class="hint">Size<label>{{information.size}}</label></font>
          <hr>
          <font class="hint">Category<label>{{information.category}}</label></font>
          <hr>
          <font class="hint">Compatibility<label v-b-toggle.compat-collapse><label class="compat-when-closed">{{information.compatibility_short}} <li class="fa fa-chevron-down"></li></label></label>
          <b-collapse id="compat-collapse"><label>{{information.compatibility}}</label></b-collapse></font>
          <hr>
          <font class="hint">Language<label v-b-toggle.language-collapse><label class="compat-when-closed">See more <li class="fa fa-chevron-down"></li></label></label>
          <b-collapse id="language-collapse"><label>{{information.language}}</label></b-collapse></font>
          <hr>
          <font class="hint">Age Rating<label>{{information.ageRating}}</label></font>
          <hr>
          <font class="hint">Copyright<label v-b-toggle.copyright-collapse><label class="compat-when-closed">See more <li class="fa fa-chevron-down"></li></label></label>
          <b-collapse id="copyright-collapse"><label>{{information.copyright}}</label></b-collapse></font>
          <hr>
          <font class="hint hint-green">Developer website<label><li class="compass-icon"></li></label></font>
          <hr>
          <font class="hint hint-green">Privacy website<label><li class="hold-icon"></li></label></font>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { dateToStringFull, timeAgo } from '../../../src/assets/utils/time';
import Loading from '../../components/Loading';
import Carousel from '@/components/Carousel.vue';

export default {
  data () {
    return {
      thumbnail: '',
      platform: '',
      app: {},
      version: {},
      isLoading: false,
      pin: '',
      pvalue: 0,
      images: [],
      showCarousel: false,
      releaseago: null,
      altImage: null,
      information: {
        provider: 'DTGO Coporation Limited.',
        size: '',
        category: 'Lifestyle',
        compatibility: '',
        compatibility_short: '',
        language: '',
        ageRating: '',
        copyright: '2018 Magnolia Quality Development',
        developerWebSite: '',
        privacyPolicy: ''
      },
      downloadMessage: 'Please download this app on your mobile phone or on your ',
      iOS: 'iPad',
      android: 'tablet'
    };
  },
  methods: {
    getData () {
      let appId = this.$route.params.appid;
      let versionId = this.$route.params.versionid;
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/landing-page/${appId}/${versionId}`, {
        headers: {
          Accept: 'application/json'
        }
      }).then(response => {
        this.isLoading = true;
        const data = response.data.data;
        if (data) {
          this.app = data.app;
          this.version = data.version;
          this.releaseago = timeAgo(new Date(this.version.createdAt));
          console.log(this.version);
          this.information.compatibility = this.version.compatibility;
          this.platform = data.app.platform;
          let defaultThumbnail = '';
          this.information.compatibility_short = 'See compatibility information:';
          if ('ios' === this.platform) {
            defaultThumbnail = '/images/app-store/thumbnail_ios.png';
            this.downloadMessage += this.iOS;
          } else {
            defaultThumbnail = '/images/app-store/thumbnail_android.png';
            this.downloadMessage += this.android;
          }
          this.thumbnail = data.version.thumbnail || defaultThumbnail;
          this.altImage = defaultThumbnail;
          this.isLoading = false;
          this.setCarouselImages(this.version.screenshots);
        }
      }).catch(error => {
        // handle later
        console.log(error);
      });
    },
    initiateDownload () {
      const versionId = this.$route.params.versionid;
      let trimmedPin = this.pin.trim();
      if (this.version.pin === trimmedPin) {
        this.pvalue = 10;
        this.pvalue = 50;
        // app-store/download
        if ('ios' === this.platform) {
          this.pvalue = 100;
          window.location.replace(`itms-services://?action=download-manifest&url=${process.env.VUE_APP_URL_UNIVERSAL_API}/app-store/download/${versionId}/${trimmedPin}`);
        } else {
          this.axios({
            method: 'get',
            url: (process.env.VUE_APP_URL_UNIVERSAL_API + `/app-store/download/${versionId}/${trimmedPin}`),
            responseType: 'blob'
          }).then(response => {
            this.Download(response);
          })
            .catch(error => {
              this.saveError = true;
              console.log('Error :', error);
            });

          setTimeout(() => {
            this.pvalue = 100;
          }, 1000);
        }
      } else {
        alert('Wrong pin, please try again.');
        this.pin = '';
      }
    },
    Download (response) {
      const blob = new Blob([response.request.response], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const contentDisposition = response.request.getResponseHeader('Content-Disposition');

      let fileName = 'unknown';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (2 === fileNameMatch.length) {
          fileName = fileNameMatch[1];
        }
      }
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    setCarouselImages (screenshots) {
      this.images = [];
      for (let i = 0; i < screenshots.length; i++) {
        let screenshot = screenshots[i];
        this.images.push({
          id: screenshot.id,
          big: screenshot.url,
          thumb: screenshot.url
        });
      }
      this.showCarousel = screenshots.length > 0;
    },
    altImg (e) {
      e.target.src = this.altImage;
    }
  },
  computed: {
    releaseDate () {
      return dateToStringFull(new Date(this.version.createdAt));
    }
  },
  mounted () {
    document.title = 'Admin Console: Download App';
    this.getData();
  },
  components: {
    'app-loading': Loading, Carousel
  }
};
</script>
<style src="@/assets/css/appstore-landing.css"></style>
